import { fetchLinks } from '@/fetchers/fetchLinks'
import VideoModal, {
	useVideoModal,
} from '@/legacy-ported/components/base/VideoModal'
import { ILink } from '@kontent-ai/delivery-sdk'
import { useQuery } from '@tanstack/react-query'
import { ReactNode } from 'react'
import { Loading } from '../Loading'
import { LinkPropsExtended } from './RichtextLinkWrapper'

interface RichtextLinkWeblinkCommonProps {
	link: ILink
	children: (_: LinkPropsExtended) => ReactNode
	preview?: boolean
}

export const RichtextLinkWeblinkCommon = ({
	link,
	children,
	preview,
}: RichtextLinkWeblinkCommonProps) => {
	// video modal
	const {
		currentVideoIframeUrl,
		openVideoModal,
		currentVideoLabel,
		openVideo,
		hideVideo,
	} = useVideoModal()

	const { data, isFetched } = useQuery({
		queryKey: ['RichtextLinkWeblinkCommon', link.codename, preview],
		queryFn: () => {
			return fetchLinks({
				codenames: [link.codename],
				preview,
			})
		},
		staleTime: Infinity,
	})

	if (!isFetched) {
		return <Loading />
	}

	if (isFetched && !data) {
		return null
	}

	// Find the link in the data
	const theLink = data.json.data?.[0]
	if (!theLink?.url) {
		return null
	}

	if (link.type === 'weblinkvideo') {
		// If the link is a video, we need to return a different component
		return (
			<>
				{children({
					href: theLink.url,
					scroll: true,
					onClick: (ev) => {
						ev.preventDefault()
						openVideo(theLink.url, theLink.title)
					},
				})}
				{openVideoModal && currentVideoIframeUrl && (
					<VideoModal
						ariaLabel={theLink.title}
						modalStatus={openVideoModal}
						onCancel={hideVideo}
						video={currentVideoIframeUrl}
					/>
				)}
			</>
		)
	}

	return (
		<>
			{children({
				href: theLink.url,
				scroll: true,
				target: link.type === 'weblinkext' ? '_blank' : undefined,
			})}
		</>
	)
}
